const toggleContent = (li) => {
	const ul = li.querySelector('ul');
	if (ul) {
		// Toggle visibility by adding/removing 'hidden' class
		ul.classList.toggle('hidden');
	}
};

export const renderJson = (strJson, container, level = 0) => {
	const json = JSON.parse(strJson);

	const type = typeof json;

	if (type === 'object' && json !== null) {
		const ul = document.createElement('ul');
		if (level === 0) {
			// Add 'root-level' to the top-level ul
			ul.className = 'ml-2 sm:ml-4 root-level';
		} else {
			// hide everything else for now.
			ul.className = 'ml-2 sm:ml-4 hidden';
		}

		container.appendChild(ul);

		for (const key in json) {
			if (key !== 'getTrackedFields' && key !== 'savedRecord') {
				const li = document.createElement('li');
				if (typeof json[key] === 'object') {
					const toggleButton = document.createElement('button');
					toggleButton.className =
						'text-left text-blue-300 cursor-pointer hover:text-blue-400 transition-all duration-300 ease-in-out';
					if (Array.isArray(json[key])) {
						toggleButton.textContent = `${key} : [ ${Object.keys(json[key]).length} ]`;
					} else {
						toggleButton.textContent = `${key} : { ${Object.keys(json[key] || {}).length} }`;
					}
					toggleButton.addEventListener('click', () => toggleContent(li));
					li.appendChild(toggleButton);
				} else {
					const keyLabel = document.createElement('label');
					keyLabel.className = 'text-blue-300';
					keyLabel.textContent = key + ': ';
					li.appendChild(keyLabel);
				}

				const valueContainer = document.createElement('span');
				renderJson(JSON.stringify(json[key]), valueContainer, level + 1);
				li.appendChild(valueContainer);

				ul.appendChild(li);
			}
		}
	} else {
		const span = document.createElement('span');
		switch (type) {
			case 'string':
				span.className = 'text-green-500';
				break;
			case 'number':
				span.className = 'text-purple-500';
				break;
			case 'boolean':
				span.className = 'text-orange-500';
				break;
			case 'object':
				span.className = 'text-gray-500';
				break;
		}
		if (type === 'string') {
			span.textContent = `"${json}"`;
		} else {
			span.textContent = json;
		}
		container.appendChild(span);
	}
};
